import { render, staticRenderFns } from "./FighterMediaEdit.vue?vue&type=template&id=07316aa4&lang=pug"
import script from "./FighterMediaEdit.vue?vue&type=script&lang=js"
export * from "./FighterMediaEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports